import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=2e6c9dde&scoped=true&"
import script from "./AddressCard.vue?vue&type=script&lang=ts&"
export * from "./AddressCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddressCard.vue?vue&type=style&index=0&id=2e6c9dde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c9dde",
  null
  
)

export default component.exports